import { Record } from 'immutable';
import StudentGeneralInfo from 'domain/StudentGeneralInfo';
import Rewards from '../Rewards';

const ACHRecord = Record({
  produced: 0,
  present: 0,
});

export class ACH extends ACHRecord { }

const StudentPerformanceRecord = Record({
  studentGeneralInfo: new StudentGeneralInfo(),
  status: undefined,
  isInProduction: undefined,
  averageSkillScores: undefined,
  averageTotalScore: undefined,
  averagePaperBasedHomeworkCompletion: undefined,
  averageOnlineHomeworkCompletion: undefined,
  averageOnlineHomeworkAccuracy: undefined,
  ach: new ACH(),
  rewards: new Rewards(),
});

class StudentPerformance extends StudentPerformanceRecord { }

export default StudentPerformance;



// WEBPACK FOOTER //
// ./data/GroupPerformance/StudentPerformance/model.js